import React from 'react';
import IconButton from './IconButton';

const CrossButton = ({ onClick, disabled }) => (
  <IconButton
    className="aridhia-cross-button"
    disabled={disabled}
    iconName="close"
    iconClassName="primary"
    iconOnly
    messageId="actions.cancel"
    onClick={onClick}
  />
);

export default CrossButton;
